import { render, staticRenderFns } from "./listOfBenefits.vue?vue&type=template&id=7cadc9c1&scoped=true&"
import script from "./listOfBenefits.vue?vue&type=script&lang=js&"
export * from "./listOfBenefits.vue?vue&type=script&lang=js&"
import style0 from "./listOfBenefits.vue?vue&type=style&index=0&id=7cadc9c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cadc9c1",
  null
  
)

component.options.__file = "listOfBenefits.vue"
export default component.exports